export const Role = {
    Root: "Root",
    Admin: "Admin",
    User: "User",
};
export const ProviderType = {
    Apple: "Apple",
    Email: "Email",
    Facebook: "Facebook",
    Github: "Github",
    Google: "Google",
    LinkedIn: "LinkedIn",
};
//# sourceMappingURL=access.js.map